import { useState } from "react";

export const useInitialState = (config = {}) => {
    const [initialState] = useState({
        pageIndex: 0,
        pageSize: 100,
        ...config
    });
    return initialState;
};